<p-dialog header="{{ productInput?.title | translate }}" [(visible)]="modalViewPricingDetailsService.visibleModal"
    [breakpoints]="{'320px': '90vw'}" [style]="{width: '50vw'}" [modal]="true">
    <p-table [value]="productInput?.prices">
        <ng-template pTemplate="header">
            <tr>
                <th class="align-center">Units</th>
                <th class="align-center">Price per unit (USD)</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-price>
            <tr>
                <td class="align-center">{{ price.units }}</td>
                <td class="align-center">{{ price.pricePerUnit }}$</td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>